import { Map } from 'immutable'
import * as UriJS from 'uri-js'
import { AsyncState, loadedAsyncState } from 'widgets-for-react'
import { ImageSize, Url } from '../../cms/blocks/types.gen'
import { CustomBlock } from '../types_and_parser/custom_blocks.mod'
import { Block } from '../types_and_parser/standard_blocks.gen'
import { ParsedFileImage } from '../types_and_parser/types.ext.gen'

export const parseImageUrl = (s: string): string =>
  s == undefined || s == null
    ? ''
    : `/drupal/media${UriJS.parse(s).path}${UriJS.parse(s).query ? '?' + UriJS.parse(s).query : ''}`

export function loadMedia(image: ParsedFileImage): AsyncState<Map<ImageSize, Url>> {
  let response
  if (image == null) {
    response = null
  } else {
    const sizes = image.style_urls
    let res = Map<ImageSize, Url>().set('full', parseImageUrl(image.url))

    for (const prop in sizes) {
      if (sizes[prop] == undefined) {
        console.warn(`Error: missing image url. ${prop} is <undefined> for image with URL ${image.url}`)
      }
    }

    if (sizes.thumbnail) res = res.set('thumbnail', parseImageUrl(sizes.thumbnail))
    if (sizes.large) res = res.set('large', parseImageUrl(sizes.large))
    if (sizes.medium) res = res.set('medium', parseImageUrl(sizes.medium))
    if (sizes.crop_thumbnail) res = res.set('crop_thumbnail', parseImageUrl(sizes.crop_thumbnail))

    if (sizes['640w']) res = res.set('640w', parseImageUrl(sizes['640w']))
    if (sizes['720w']) res = res.set('720w', parseImageUrl(sizes['720w']))
    if (sizes['1280w']) res = res.set('1280w', parseImageUrl(sizes['1280w']))
    if (sizes['1920w']) res = res.set('1920w', parseImageUrl(sizes['1920w']))
    if (sizes['2880w']) res = res.set('2880w', parseImageUrl(sizes['2880w']))

    // VAN OORD

    if (sizes['560x280']) res = res.set('560x280', parseImageUrl(sizes['560x280']))
    if (sizes['720x360']) res = res.set('720x360', parseImageUrl(sizes['720x360']))
    if (sizes['1440x720']) res = res.set('1440x720', parseImageUrl(sizes['1440x720']))

    if (sizes['2720x1360']) res = res.set('2720x1360', parseImageUrl(sizes['2720x1360']))
    if (sizes['1360x680']) res = res.set('1360x680', parseImageUrl(sizes['1360x680']))
    if (sizes['680x340']) res = res.set('680x340', parseImageUrl(sizes['680x340']))

    if (sizes['720w']) res = res.set('720w', parseImageUrl(sizes['720w']))
    if (sizes['1440w']) res = res.set('1440w', parseImageUrl(sizes['1440w']))
    if (sizes['2880w']) res = res.set('2880w', parseImageUrl(sizes['2880w']))

    if (sizes['320x320']) res = res.set('320x320', parseImageUrl(sizes['320x320']))
    if (sizes['640x640']) res = res.set('640x640', parseImageUrl(sizes['640x640']))

    if (sizes['1600x1200']) res = res.set('1600x1200', parseImageUrl(sizes['1600x1200']))
    if (sizes['800x600']) res = res.set('800x600', parseImageUrl(sizes['800x600']))
    if (sizes['400x300']) res = res.set('400x300', parseImageUrl(sizes['400x300']))
    if (sizes['1100x1100']) res = res.set('1100x1100', parseImageUrl(sizes['1100x1100']))
    if (sizes['555x555']) res = res.set('555x555', parseImageUrl(sizes['555x555']))
    if (sizes['280x280']) res = res.set('280x280', parseImageUrl(sizes['280x280']))

    if (sizes['580x580']) res = res.set('580x580', parseImageUrl(sizes['580x580']))
    if (sizes['640x640']) res = res.set('640x640', parseImageUrl(sizes['640x640']))
    if (sizes['1280x1280']) res = res.set('1280x1280', parseImageUrl(sizes['1280x1280']))
    if (sizes['1920x1920']) res = res.set('1920x1920', parseImageUrl(sizes['1920x1920']))

    if (sizes['175x175']) res = res.set('175x175', parseImageUrl(sizes['175x175']))
    if (sizes['345x345']) res = res.set('345x345', parseImageUrl(sizes['345x345']))
    if (sizes['690x690']) res = res.set('690x690', parseImageUrl(sizes['690x690']))

    if (sizes['480x300']) res = res.set('480x300', parseImageUrl(sizes['480x300']))
    if (sizes['960x600']) res = res.set('960x600', parseImageUrl(sizes['960x600']))
    if (sizes['1440x900']) res = res.set('1440x900', parseImageUrl(sizes['1440x900']))

    response = res
  }

  return loadedAsyncState<Map<ImageSize, Url>>(response)
}

export const GetDrupalBlockImagesLoaders = (
  block: Block | CustomBlock,
): Array<[number, AsyncState<Map<ImageSize, Url>>]> => {
  switch (block.kind) {
    case 'featured_content':
      return [
        [
          block.field_featured_content.field_introduction_image &&
            block.field_featured_content.field_introduction_image.bundle === 'image' &&
            block.field_featured_content.field_introduction_image.field_media_image &&
            block.field_featured_content.field_introduction_image.field_media_image.image.id
            ? block.field_featured_content.field_introduction_image.field_media_image.image.id
            : null,
          loadMedia(
            block.field_featured_content.field_introduction_image &&
              block.field_featured_content.field_introduction_image.bundle === 'image' &&
              block.field_featured_content.field_introduction_image.field_media_image &&
              block.field_featured_content.field_introduction_image.field_media_image.image.id
              ? block.field_featured_content.field_introduction_image.field_media_image.image
              : null
          )
        ]
      ]
    case 'text_with_image':
      return [
        [
          block.field_image &&
            block.field_image.bundle === 'image' &&
            block.field_image.field_media_image &&
            block.field_image.field_media_image.image.id
            ? block.field_image.field_media_image.image.id
            : null,
          loadMedia(
            block.field_image &&
              block.field_image.bundle === 'image' &&
              block.field_image.field_media_image &&
              block.field_image.field_media_image.image.id
              ? block.field_image.field_media_image.image
              : null
          )
        ]
      ]
    case 'double_text_with_image':
      return [
        [
          block.field_image &&
            block.field_image.bundle === 'image' &&
            block.field_image.field_media_image &&
            block.field_image.field_media_image.image.id
            ? block.field_image.field_media_image.image.id
            : null,
          loadMedia(
            block.field_image &&
              block.field_image.bundle === 'image' &&
              block.field_image.field_media_image &&
              block.field_image.field_media_image.image.id
              ? block.field_image.field_media_image.image
              : null
          )
        ],
        [
          block.field_secondary_image &&
            block.field_secondary_image.bundle === 'image' &&
            block.field_secondary_image.field_media_image &&
            block.field_secondary_image.field_media_image.image.id
            ? block.field_secondary_image.field_media_image.image.id
            : null,
          loadMedia(
            block.field_secondary_image &&
              block.field_secondary_image.bundle === 'image' &&
              block.field_secondary_image.field_media_image &&
              block.field_secondary_image.field_media_image.image.id
              ? block.field_secondary_image.field_media_image.image
              : null
          )
        ]
      ]
    case 'grid_blocks_image':
      return block.field_grid_blocks
        .map((b) : [number, AsyncState<Map<ImageSize, Url>>]=>
          [
            b.field_image.field_media_image.image.id,
            loadMedia(b.field_image.field_media_image.image)
          ]
        )
        .toArray()
    case 'image_gallery':
      return block.field_image_gallery
        .map((b) : [number, AsyncState<Map<ImageSize, Url>>]=>
          [
            b.field_image.field_media_image.image.id,
            loadMedia(b.field_image.field_media_image.image)
          ]
        )
        .toArray()
    case 'media':
      const images = block.field_media_item?.filter((x) => x.field_media.bundle === 'image')
      return block.field_media_item
        .map((b) : [number, AsyncState<Map<ImageSize, Url>>]=>
          [
            b.field_media?.bundle === 'image' ? b.field_media.field_media_image?.image?.id : null,
            loadMedia(b.field_media?.bundle === 'image' ? b.field_media.field_media_image.image : null)
          ]
        )
        .toArray()
    case 'media_nested':
      const imagesNested = block.field_media_item?.filter((x) => x.field_media.bundle === 'image')
      return block.field_media_item
        .map((b) : [number, AsyncState<Map<ImageSize, Url>>]=>
          [
            b.field_media?.bundle === 'image' ? b.field_media.field_media_image?.image?.id : null,
            loadMedia(b.field_media?.bundle === 'image' ? b.field_media.field_media_image.image : null)
          ]
        )
        .toArray()
    case 'cta':
      return [
        [
          block.field_image &&
            block.field_image.bundle === 'image' &&
            block.field_image.field_media_image &&
            block.field_image.field_media_image.image.id
            ? block.field_image.field_media_image.image.id
            : null,
          loadMedia(
            block.field_image &&
              block.field_image.bundle === 'image' &&
              block.field_image.field_media_image &&
              block.field_image.field_media_image.image.id
              ? block.field_image.field_media_image.image
              : null
          )
        ]
      ]
    case 'quote_with_image':
      return [
        [
          block.field_image &&
            block.field_image.bundle === 'image' &&
            block.field_image.field_media_image &&
            block.field_image.field_media_image.image.id
            ? block.field_image.field_media_image.image.id
            : null,
          loadMedia(
            block.field_image &&
              block.field_image.bundle === 'image' &&
              block.field_image.field_media_image &&
              block.field_image.field_media_image.image.id
              ? block.field_image.field_media_image.image
              : null
          )
        ]
      ]
    case 'text_with_read_more':
      const imagesTWRM: Array<[number, AsyncState<Map<ImageSize, Url>>]> = []
      block.field_read_more
        .forEach((frm) => {
          const ppm = frm
          if (ppm.bundle === 'media_nested') ppm.field_media_item.forEach((fmi) => {
            const imageId = fmi.field_media.bundle === 'image' ? fmi.field_media.field_media_image.image.id : null
            const imageData = fmi.field_media.bundle === 'image' ? fmi.field_media.field_media_image.image : null
            imagesTWRM.push([imageId, loadMedia(imageData)])
          })
        })
      return imagesTWRM
    case '360_building_block':
      return [
        [
          block.field_image &&
            block.field_image.bundle === 'image' &&
            block.field_image.field_media_image &&
            block.field_image.field_media_image.image.id
            ? block.field_image.field_media_image.image.id
            : null,

          loadMedia(
            block.field_image &&
              block.field_image.bundle === 'image' &&
              block.field_image.field_media_image &&
              block.field_image.field_media_image.image.id
              ? block.field_image.field_media_image.image
              : null
          )
        ],
        [
          block.field_preview_image &&
            block.field_preview_image.bundle === 'image' &&
            block.field_preview_image.field_media_image &&
            block.field_preview_image.field_media_image.image.id
            ? block.field_preview_image.field_media_image.image.id
            : null,

          loadMedia(
            block.field_preview_image &&
              block.field_preview_image.bundle === 'image' &&
              block.field_preview_image.field_media_image &&
              block.field_preview_image.field_media_image.image.id
              ? block.field_preview_image.field_media_image.image
              : null
          )
        ]
      ]
    case 'development_block':
      return block.field_images
        .map((b) : [number, AsyncState<Map<ImageSize, Url>>] =>
          [
            b.field_media_image.image.id,
            loadMedia(b.field_media_image.image)
          ]
        )
        .toArray()
    default:
      return []
  }
}
